import { render } from "./department-list-modal.vue?vue&type=template&id=3ebadff0"
import script from "./department-list-modal.vue?vue&type=script&lang=js"
export * from "./department-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__